import React from "react";
import { NavLink } from "react-router-dom";
import Cta from "../../components/cta/cta";
import IndustryLeaders from "../../components/industry-leaders/industry-leaders";
import Testimonials from "../../components/home/Testimonials";
import channelBanner from "../../assets/images/review/channel-banner.png";
import sra from "../../assets/images/review/sra.png";
import adb from "../../assets/images/review/adb.png";
import may from "../../assets/images/review/mayl.png";
import IntegrationBanner from "../../assets/images/integration/integrationBanner.png";

const ChannelPage = () => {
  return (
    <>
      <div className="sales-main-wrapper">
        <section className="sa-banner">
          <div className="max-container">
            <div className="padd-90">
              <div className="grid-auto-fit align-items-center max-width950">
                <div>
                  <h1 className="heading39px roboto-bold mb20 text-color-131415">
                    Unlock More Opportunities with Our <br />{" "}
                    <span className="text-primary-color">Channel Manager</span>
                  </h1>
                  <p className="heading16px roboto-regular mb30">
                    Expand your property’s visibility effortlessly across
                    multiple platforms. Our channel manager helps you reach more
                    customers by distributing your listings to over 50+ trusted
                    booking channels.
                  </p>

                  <ul className="btn-sec">
                    <li>
                      <NavLink
                        to={"/signup"}
                        className="common-btn-class main-btn-primary roboto-regular"
                      >
                        {" "}
                        Subscribe Now
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to={"/contact-us"}
                        className="common-btn-class transparentBtn roboto-regular"
                      >
                        Contact us
                      </NavLink>
                    </li>
                  </ul>
                </div>
                <div>
                  <img
                    src={channelBanner}
                    className="img-responsive"
                    alt="Unlock More Opportunities with Our Channel Manager"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <IndustryLeaders />

        <section className="">
          <div className="max-container">
            <div className="padd-90">
              <h2 className="roboto-bold mb10 heading29px mb60 text-center">
                Broaden Your Distribution and <br /> Reach More Potential
                Customers
              </h2>
              <div className="grid-auto-fit align-items-center mb60 max-width950">
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Simple Integration with Popular <br /> Travel Platforms
                  </h3>
                  <p className="heading16px roboto-regular">
                    Easily connect to major platforms like Airbnb, Vrbo, and
                    Booking.com. Our seamless integration keeps your listings
                    up-to-date with zero hassle.
                  </p>
                </div>
                <div>
                  <img
                    src={IntegrationBanner}
                    alt="Simple Integration with Popular Travel Platforms"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
              </div>

              <div className="grid-auto-fit align-items-center mb60 max-width950">
                <div className="block-order2">
                  <img
                    src={sra}
                    alt="Sync Rates and Availability in Real-Time"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Sync Rates and Availability in Real-Time
                  </h3>
                  <p className="heading16px roboto-regular">
                    Ensure consistency with real-time syncing of rates and
                    availability across all your channels. Any change you make
                    is instantly reflected, preventing errors and maximizing
                    bookings.
                  </p>
                </div>
              </div>

              <div className="grid-auto-fit align-items-center mb60 max-width950">
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Avoid Double Bookings with Smart Calendar Management
                  </h3>
                  <p className="heading16px roboto-regular">
                    Our smart calendar management updates availability
                    automatically, helping you avoid double bookings and
                    ensuring peace of mind.
                  </p>
                </div>
                <div>
                  <img
                    src={adb}
                    alt="Avoid Double Bookings with Smart Calendar Management"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
              </div>

              <div className="grid-auto-fit align-items-center max-width950">
                <div className="block-order2">
                  <img
                    src={may}
                    alt="Manage All Your Listings from One Dashboard"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Manage All Your Listings from One Dashboard
                  </h3>
                  <p className="heading16px roboto-regular">
                    Control everything from a single, easy-to-use dashboard.
                    Update rates, availability, and content in one place—saving
                    you time and effort.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Cta
          heading="Reach Your Ideal Customer With Us"
          firstCta="/signup"
          firstCtaText="Subscribe Now"
          secondCta="/contact-us"
          secondCtaText="Contact us"
        />

        <Testimonials />
      </div>
    </>
  );
};

export default ChannelPage;
